import { motion } from 'framer-motion';

const base = { opacity: 0, y: 22 };

export const Reveal = ({ children, delay = 0, y = 22, className = '', as = 'div', ...rest }) => {
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      initial={{ ...base, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </M>
  );
};

export const Stagger = ({ children, className = '', gap = 0.08 }) => (
  <motion.div
    className={className}
    initial="hide"
    whileInView="show"
    viewport={{ once: true, margin: '-60px' }}
    variants={{ show: { transition: { staggerChildren: gap } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = '' }) => (
  <motion.div
    className={className}
    variants={{ hide: { opacity: 0, y: 22 }, show: { opacity: 1, y: 0 } }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);
